import React from "react";
import { useSearchParams } from "react-router-dom";
import AllResultsCard from "./allResultsCard";
import FeaturedSnippetBox from "./featuredSnippet";
import AccordionComponent from "../layout/accordion";
import RelatedSearches from "./relatedSearches";
import KnowledgePanel from "./knowledgePanel";
import { Content } from "../../data/registry";

const All = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get("q") || "";

  const all = Content;
  const first = Content.slice(0, 1);
  const theRest = Content.slice(1);

  return (
    <div className="results-with-panel">
      <div className="results-main-column">
        <p className="result-count">About {all.length} results (0.67 seconds)</p>
        <FeaturedSnippetBox query={query} />
        <AllResultsCard results={first} />
        <AccordionComponent />
        <AllResultsCard results={theRest} />
        <RelatedSearches />
      </div>
      <KnowledgePanel />
    </div>
  );
};

export default All;
